import React from "react";
import HomeContent from "../../components/Home";
import NewLayout from "../../layout/dashboard/NewLayout";

const HomePage2 = () => {
  return (
    <NewLayout>
      <HomeContent />
    </NewLayout>
  );
};

export default HomePage2;
